package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource

/**
 * Wrapper per supportare sia stringhe statiche (StringResource) che dinamiche (String)
 */
sealed class QuizText {
    data class Resource(val resource: StringResource, val args: List<Any> = emptyList()) : QuizText()
    data class Plain(val text: String) : QuizText()
}

